import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MenuList, MenuListItem } from 'excellence-ui';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { HasRoleDirective } from '../../../../shared/directives/has-role';
import { DocumentDownloadButton } from '../document-download-button/document-download-button';
import { HasPermissionDirective } from '../../../organizations/directives/has-permission';
import { DisableInDemoModeDirective } from '../../../demo/directives/disable-in-demo-mode';

@Component({
  selector: 'app-document-table-row-contextmenu',
  imports: [
    MenuList,
    MenuListItem,
    TranslocoPipe,
    HasRoleDirective,
    DocumentDownloadButton,
    HasPermissionDirective,
    DisableInDemoModeDirective,
  ],
  templateUrl: './document-table-row-contextmenu.html',
})
export class DocumentTableRowContextmenu {
  document = input.required<FileResponse>();
  organizationId = input.required<string>();

  clickEdit = output();
  clickOpen = output();
  clickShare = output();
  clickDelete = output();

  dismiss = output();
}
